import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d9b95196"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d9b95196&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9b95196')) {
      api.createRecord('d9b95196', component.options)
    } else {
      api.reload('d9b95196', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d9b95196", function () {
      api.rerender('d9b95196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gradientColorSelector/index.vue"
export default component.exports